import React from 'react';
import { Box, IconButton, Icons } from '@curves/ui-base';

import NavLogo from '@Images/nav_logo.svg';

import clsx from 'clsx';
const TopBarStart = (props) => {
    const {className, onToggleMenu} = props;
    return (
        <Box className={clsx('top-bar-start', className)}>
            <IconButton className={'top-bar-menu-button'} onClick={() => typeof onToggleMenu === 'function' && onToggleMenu()}>
                <Icons.Bars/>
            </IconButton>
            <Box className={'logo-wrap'}>
                <Box component={'img'} src={NavLogo} className={'logo'} alt={'Curves總部'}/>
            </Box>
        </Box>
    );
};
export default TopBarStart;
